import React, { useState } from "react";
import Webmenu from "../../../layouts/webmenu";
import Topbar from "../../../layouts/topbar";
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import { getAllInsuranceCompany, saveInsuranceCompany, updateInsuranceCompany } from "../../../actions/InsuranceCompanyActions";
import Toast from "../../../components/Toast";
import { useEffect } from "react";

function AddInsuranceCompanies(props) {

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const { editinsuranceCompanies, modalType, getData, currentRowsPerPage, page } = props;

    const [name, setName] = useState('');
    const [vat, setVat] = useState('');
    const [phone, setPhone] = useState('');
    const [crtn, setCrtn] = useState('');
    const [address, setAddress] = useState('');

    const save = async () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                vat: vat,
                phone: phone,
                crtn: crtn,
                address: address,
            }
            await dispatch(saveInsuranceCompany(data));
            dispatch(getAllInsuranceCompany(page, currentRowsPerPage));
        }
        // window.location.href = ('/insuranceCompany');
        setName("");
        setVat("");
        setPhone("");
        setCrtn("");
        setAddress("");
    }

    useEffect(() => {
        if (editinsuranceCompanies && Object.keys(editinsuranceCompanies).length > 0) {
            setName(editinsuranceCompanies.name);
            setPhone(editinsuranceCompanies?.phone);
            setVat(editinsuranceCompanies?.vat);
            setCrtn(editinsuranceCompanies?.crtn);
            setAddress(editinsuranceCompanies?.address);
        }
    }, [editinsuranceCompanies])

    const update = async () => {
        if (name.length == 0) {
            Toast.fire({
                icon: 'error',
                title: 'Name is Required!'
            })
        } else {
            let data = {
                name: name,
                vat: vat,
                phone: phone,
                crtn: crtn,
                address: address,
            }
            await dispatch(updateInsuranceCompany(data, editinsuranceCompanies.insurance_company_id));
            dispatch(getAllInsuranceCompany(page, currentRowsPerPage));
            // dispatch(getAllState());
        }
        // // window.location.href = ('/state')
        setName("");
        setVat("");
        setPhone("");
        setCrtn("");
        setAddress("");
    }
    const clearName = () => {
        setName("");
        setVat("");
        setPhone("");
        setCrtn("");
        setAddress("");
    };
    return (
        <React.Fragment>
            {/* <!-- BEGIN: Modal Content --> */}
            <div id="add-modal" class="modal fade" data-bs-backdrop="static" tabindex="-1" aria-hidden="true">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        {/* <!-- BEGIN: Modal Header --> */}
                        <div class="modal-header">
                            <h2 class="fw-medium fs-base me-auto">{modalType == 'add' ? 'Add' : 'Edit'} Insurance Company Name</h2>
                        </div>
                        {/* <!-- END: Modal Header --> */}
                        {/* <!-- BEGIN: Modal Body --> */}
                        <div className="grid columns-12 gap-6">
                            <div className="intro-y g-col-12">
                                {/* <!-- BEGIN: Form Layout --> */}
                                <div className="intro-y grid columns-12 p-5">
                                    <div className="intro-y g-col-6">
                                        <label for="crud-form-1" className="form-label">Insurance Company Name</label>
                                        <input id="crud-form-1" value={name} onChange={(e) => setName(e.target.value)} type="text" className="form-control w-full" placeholder={name == "" ? "Enter Name..." : (e) => e.target.value} />
                                    </div>
                                    <div className="intro-y g-col-6">
                                        <label for="crud-form-1" className="form-label">Phone</label>
                                        <input id="crud-form-1" value={phone} onChange={(e) => setPhone(e.target.value)} type="text" className="form-control w-full" placeholder={phone == "" ? "Enter Phone..." : (e) => e.target.value} />
                                    </div>
                                    <div className="intro-y g-col-6">
                                        <label for="crud-form-1" className="form-label">Vat Trn #</label>
                                        <input id="crud-form-1" value={vat} onChange={(e) => setVat(e.target.value)} type="text" className="form-control w-full" placeholder={vat == "" ? "Enter Vat..." : (e) => e.target.value} />
                                    </div>
                                    <div className="intro-y g-col-6">
                                        <label for="crud-form-1" className="form-label">CRTN #</label>
                                        <input id="crud-form-1" value={crtn} onChange={(e) => setCrtn(e.target.value)} type="text" className="form-control w-full" placeholder={crtn == "" ? "Enter CRTN..." : (e) => e.target.value} />
                                    </div>
                                    <div className="intro-y g-col-12">
                                        <label for="crud-form-1" className="form-label">Address</label>
                                        <textarea id="note" onChange={(e) => setAddress(e.target.value)} value={address} name="note" type="text" rows={4} className="form-control" placeholder="Enter Address" />
                                    </div>
                                    {/* <div className="mt-3">
                                    <label>Status</label>
                                    <div className="form-check form-switch mt-2">
                                        <input type="checkbox" className="form-check-input"/>
                                    </div>
                                </div> */}
                                </div>
                                {/* <!-- END: Form Layout --> */}
                            </div>
                        </div>
                        {/* <!-- END: Modal Body --> */}
                        {/* <!-- BEGIN: Modal Footer --> */}
                        <div class="modal-footer text-end">
                            <div className="text-end">
                                <button type="button" data-bs-dismiss="modal" onClick={clearName} className="btn btn-outline-secondary w-24 me-1">Back</button>
                                {
                                    modalType == 'add' ?
                                        <span>
                                            <button type="button" data-bs-dismiss="modal" onClick={save} className="btn btn-primary w-24 me-1">Save</button>
                                            <button type="button" onClick={save} className="btn btn-primary">Save & Add More</button>
                                        </span>
                                        :
                                        <button type="button" data-bs-dismiss="modal" onClick={update} className="btn btn-primary w-24">Update</button>
                                }
                            </div>
                        </div>
                        {/* <!-- END: Modal Footer --> */}
                    </div>
                </div>
            </div>
            {/* <!-- END: Modal Content --> */}
        </React.Fragment>
    )
}

export default AddInsuranceCompanies;